import queryString from 'query-string'

export const prepareUrl = (obj = {}) => {
  const params = Object.keys(obj)
    .filter(key => !(obj[key] === '' || obj[key] === false || (Array.isArray(obj[key]) && !obj[key].length)))
    .reduce((acc, key) => {
      acc[key] = obj[key]

      if (Array.isArray(acc[key])) {
        acc[key] = acc[key].map(value => value.toString()).join(',')
      }

      return acc
    }, {})

  return queryString.stringify(params)
}

export const getPaginatedTableQuery = meta => ({
  limit: meta.rowsPerPage || 25,
  offset: meta.page * meta.rowsPerPage || 0,

  sort_by: meta.sortBy,
  sort: meta.sortOrder,

  // `|| undefined` omits the falsy toggle from the query string entirely.
  admin: meta.filters?.admin || undefined,
  search: meta.filters?.search,
  id: meta.filters?.id || undefined,
  workflow_manual_approval: meta.filters?.workflowManualApproval,
  show_deleted: meta.filters?.showDeleted,
  plan_id: meta.filters?.plan_id,
  code_status: meta.filters?.code_status,
})

export const getPaginationParams = p => ({
  limit: p.get('rowsPerPage'),
  offset: p.get('page') * p.get('rowsPerPage'),
})

export const getCollectionUrlParams = p =>
  prepareUrl({
    // pagination
    ...getPaginationParams(p),

    // sorting
    sort_by: p.get('sortBy'),
    sort: p.get('sortOrder'),

    // filters
    admin: p.get('filter')?.admin,
    search: p.get('filter')?.search,
    workflow_manual_approval: p.get('filter')?.workflowManualApproval,
  })
